import { ref } from 'vue';

// Die Meldungen oben (Update-Hinweis, Wartungsfenster) liegen im selben Bereich. Damit sie sich nicht überdecken,
// meldet der Update-Hinweis hier, ob er sichtbar ist.
export const updateBannerVisible = ref(false);
